var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "446616E7-06BA-43D9-AFB4-876B3BA9FABD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 28,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Theme-Setup",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sticker-Sheet",
    transform: "translate(-310.000000, -836.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/ascending-Copy-49",
    transform: "translate(310.000000, 836.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "2 2 26 2 26 26 2 26"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Hover-Style"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "State"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.1081731,9.54133333 L19.1081731,6 L8.89182692,6 L8.89182692,9.54133333 L19.1081731,9.54133333 Z M19.1081731,22 L19.1081731,18.4586667 L22.5,18.4586667 L22.5,13.1253333 C22.5,12.656 22.3842147,12.2151111 22.1526442,11.8026667 C21.9210737,11.3902222 21.6077724,11.0631111 21.2127404,10.8213333 C20.8177083,10.5795556 20.3954327,10.4586667 19.9459135,10.4586667 L19.9459135,10.4586667 L8.05408654,10.4586667 C7.60456731,10.4586667 7.18229167,10.5795556 6.78725962,10.8213333 C6.39222756,11.0631111 6.07892628,11.3902222 5.84735577,11.8026667 C5.61578526,12.2151111 5.5,12.656 5.5,13.1253333 L5.5,13.1253333 L5.5,18.4586667 L8.89182692,18.4586667 L8.89182692,22 L19.1081731,22 Z M19.9459135,14 C19.7143429,14 19.5168269,13.9182222 19.3533654,13.7546667 C19.1899038,13.5911111 19.1081731,13.3813333 19.1081731,13.1253333 C19.1081731,12.8693333 19.1864984,12.6524444 19.343149,12.4746667 C19.4997997,12.2968889 19.7007212,12.208 19.9459135,12.208 C20.1911058,12.208 20.3988381,12.3004444 20.5691106,12.4853333 C20.739383,12.6702222 20.8245192,12.8835556 20.8245192,13.1253333 C20.8245192,13.3671111 20.739383,13.5733333 20.5691106,13.744 C20.3988381,13.9146667 20.1911058,14 19.9459135,14 Z M17.3918269,20.208 L10.6081731,20.208 L10.6081731,15.792 L17.3918269,15.792 L17.3918269,20.208 Z",
    id: "Icon-Color",
    fill: "#50566E"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.4b9b8f0cb70268e54ee0ed8324ffd34c.svg";
export { ForwardRef as ReactComponent };